export default __webpack_public_path__ + "static/media/new-stories.66cae471.svg";